import { render, staticRenderFns } from "./MovesViewer.vue?vue&type=template&id=2b2fae8d&"
import script from "./MovesViewer.vue?vue&type=script&lang=js&"
export * from "./MovesViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports